import type { Currency } from './api/types'

// Currency is shown as its ISO 4217 code (UAH/USD/EUR), not a glyph, so amounts
// are unambiguous across locales. The code is placed AFTER the amount
// (e.g. "1 000.00 UAH"). The Currency union values are already the codes.
function group(whole: string): string {
  return whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export function fmtMoney(amount: number, currency: Currency, opts: { sign?: boolean } = {}): string {
  const showSign = opts.sign ?? false
  const sign = amount < 0 ? '−' : showSign && amount > 0 ? '+' : ''
  const abs = Math.abs(amount)
  const whole = Math.floor(abs)
  const frac = Math.round((abs - whole) * 100)
    .toString()
    .padStart(2, '0')
  return `${sign}${group(whole.toString())}.${frac} ${currency}`
}

export function fmtMoneyShort(amount: number, currency: Currency): string {
  const sign = amount < 0 ? '−' : ''
  const abs = Math.abs(amount)
  const whole = Math.floor(abs)
  return `${sign}${group(whole.toString())} ${currency}`
}

export function currencyCode(currency: Currency): string {
  return currency
}
